
<template>
  <div>
    <v-avatar class="ma-3 avatar" :color="oneEmployee.data.attributes.document ? '' : 'secondary'" size="80">
      <v-badge color="primary" class="avatar_badge" avatar bottom>
        <template v-slot:badge >
          <v-btn icon small dark class="btn" @click="openDialog">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <v-icon v-if="!oneEmployee.data.attributes.document" large dark>mdi-account</v-icon>
        <v-img v-if="oneEmployee.data.attributes.document" :src="oneEmployee.data.attributes.document.document"
          class="my-3" />
      </v-badge>
    </v-avatar>

    <dialog-edit-avatar ref="dialog" @doneAvatar='handleDoneAvatar' :oneEmployee="oneEmployee"></dialog-edit-avatar>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogEditAvatar from './DialogEditAvatar.vue'

export default {
  name: 'ShowAvatar',
  components: { DialogEditAvatar },
  props: {
    oneEmployee: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
    };
  },
  methods: {
    handleDoneAvatar(e) {
      this.$emit('doneAvatar', e)
    },
    openDialog(){
      this.$refs.dialog.dialog = true
    }
  },
  computed: {
    ...mapState({
      //oneEmployee: state => state.Employee.oneEmployee,
    })
  },
}
</script>

<style scoped>
  .avatar{
    overflow: visible !important;
  }
  .btn{
    width: 100%;
    height: 100% !important;
    padding: 2px 2px;
  }
</style>
<style>
  .avatar_badge span.v-badge__badge.primary{
    height: 30px !important;
    width: 30px !important;
    border-radius: 30px;
  }

</style>